export function canCreateRequest(claims, user) {
  return claims?.role === "SYSTEM_USER" ||
    (claims?.role === "CLIENT" && user?.allowRequestCreation !== false)
}

// Only an explicit false hides statistics, so system users created before the flag keep access.
export function canViewStatistics(claims, user) {
  return claims?.role === "SYSTEM_USER" && user?.canViewStatistics !== false
}

export const STATISTICS_ROUTE_NAMES = ["Dashboard", "Employee statistics", "Organization statistics"]

// Backend error codes arrive as HttpsError details {tag: "<CODE>"}; older callables sent the bare string.
export function getErrorTag(error) {
  const details = error?.details
  if (details == null) return null
  if (typeof details === "string") return details
  return details.tag ?? null
}

export function requestErrorMessage(error, translate) {
  if (getErrorTag(error) === "PENALTY_NOT_ALLOWED") {
    return translate("A penalty can only be issued when AllCare cancels a claimed request.")
  }
  if (getErrorTag(error) === "REGISTRATION_EXPIRED" || error?.message === "Registration expires before this shift starts") {
    return translate("Your registration expires before this shift starts. Please renew your registration before booking.")
  }
  if (error?.message === "You are not allowed to create or update requests") {
    return translate("You are not allowed to create or edit requests. Please contact your administrator.")
  }
  return error?.message || translate("Something went wrong!")
}

export function canEditRequest(request, claims, now = new Date(), user) {
  if (!canCreateRequest(claims, user)) return false
  if (!request || request.status !== "VERIFIED") return false
  if (claims.role === "SYSTEM_USER") return true
  return claims.role === "CLIENT" && request.clientId === claims.clientId &&
    request.mStartDate?.toDate() > now
}


export function getRequestDeadlineOptions(translate) {
  return [
    {key: 0, label: translate("At shift start")},
    {key: 10 / 1440, label: translate("10 minutes before")},
    {key: 1 / 24, label: translate("1 hour before")},
    ...[3, 6, 12].map(hours => ({key: hours / 24, label: translate(`${hours} hours before`)})),
    ...[1, 3, 5, 7, 10, 15, 20].map(days => ({key: days, label: translate("countDays", {count: days})}))
  ]
}
